import { createFileRoute } from '@tanstack/react-router'

import { z } from 'zod'

import { CanvasContainer } from '@/pages/Workflows/ProcessCanvas/CanvasContainer'

export const Route = createFileRoute(
  '/_app/library/processes/$processId/canvas',
)({
  validateSearch: z.object({
    automationId: z.string().optional(),
    planId: z.string().optional(),
  }),
  component: CanvasContainer,
})
